import styled from 'styled-components'

export const DescriptionContainer = styled.div`
  line-height: 24px;
`
